// EditPermission — modal-embedded form for updating a Permission row.
// Refactored 2026-05-05 (Phase 3.1, Class P) onto ModalFormHeader.

import React, { useState } from 'react';
import CTextField from '../CTextField/CTextField';
import { Button, Stack, Box, Typography } from '@mui/material';
import { LockOpenOutlined } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { updatePermission } from '../../feature/permissionsSlice';
import CSwitch from '../CSwitch/CSwitch';
import { toast } from 'react-toastify';
import { ModalFormHeader } from '../PaperForm';

const EditPermission = (props) => {
  const { id, name } = props.data;
  const dispatch = useDispatch();
  const [isActive, setActive] = useState(props.data.isActive);
  const [data, setData] = useState({
    id: id,
    name: name,
    roleId: id,
  });

  const handleChange = (event) => {
    setData((prv) => ({ ...prv, [event.target.name]: event.target.value }));
  };

  const handleSubmit = () => {
    let fd = { ...data, isActive };
    dispatch(updatePermission(fd)).then((res) => {
      if (res.type === 'updatePermissions/permissions/fulfilled') {
        toast('Permission updated successfully!');
        props.setOpen(false);
      }
    });
  };

  return (
    <Box>
      <ModalFormHeader
        overline="SFM · Permission"
        title="Update Permission"
        icon={LockOpenOutlined}
        rightSlot={
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <Typography variant="caption" sx={{ color: 'text.secondary' }}>Active</Typography>
            <CSwitch label="Active" active={isActive} setSwitch={() => setActive(!isActive)} />
          </Stack>
        }
      />
      <Stack spacing={2}>
        <CTextField onChange={handleChange} defaultValue={name} name="name" label="Permission name" />
        <Button
          disabled={props.isLoading}
          onClick={handleSubmit}
          variant="contained"
          sx={{
            width: '100%',
            mt: 1,
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            letterSpacing: '0.01em',
          }}
        >
          {props.isLoading ? 'Loading…' : 'Save changes'}
        </Button>
      </Stack>
    </Box>
  );
};

export default EditPermission;
